import { ObjectHelpers } from "../../helpers/object-helpers";

export class TradePositionDataModel {
    public accountId = '';
    public symbol = '';
    public averageCost = 0;
    public lastPrice = 0;
    public shares = 0;
    public totalProfit = 0;
    public realizedProfitLoss = 0;
    public unrealizedProfit = 0;
    public netSharesTradedToday = 0;
    public iChangeFromCloseDollar = 0;
    public iChangeFromClosePercent = 0;
    public iLast = 0;
    public id = 0;

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }
}